import React, { FC } from 'react';

import { IconNameType } from '../icons/icon-name.type';
import Icon from '../icons';
type HandleMetricSpecialTogglePropsType = {
  valuesList: Array<{
    value: string;
    title: string;
    icon?: IconNameType;
    iconPosition?: 'left' | 'right';
    iconSize?: number;
    iconClassName?: string;
  }>;
  isActive: string | undefined;
  onChange(value: string): void;
  disabled?: boolean;
};
const SegmentedControl: FC<HandleMetricSpecialTogglePropsType> = (props) => {
  const { valuesList, isActive, onChange, disabled = false } = props;
  return (
    <div
      className={`w-full flex items-center justify-around bg-basic_app_bg rounded-[12px] p-[2px] shadow-md`}
    >
      {valuesList.map((currentValue) => (
        <div
          onClick={() => !disabled && onChange(currentValue.value)}
          className={`${
            isActive === currentValue.value && 'bg-white !border-b_dark'
          } py-[8px] transition-all duration-300 ${
            !disabled ? 'hover:bg-white' : '!cursor-not-allowed'
          } w-full text-[14px] text-center cursor-pointer border-[1px] border-transparent rounded-[10px] flex items-center gap-[5px] justify-center`}
          key={currentValue.value}
        >
          {currentValue.icon && currentValue.iconPosition !== 'right' && (
            <Icon
              className={currentValue.iconClassName}
              name={currentValue.icon}
              size={currentValue.iconSize}
            />
          )}
          {currentValue.title}
          {currentValue.icon && currentValue.iconPosition === 'right' && (
            <Icon
              className={currentValue.iconClassName}
              name={currentValue.icon}
              size={currentValue.iconSize}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SegmentedControl;
